import React from "react";
import { splitPlaceholders } from "@/lib/polishedAnswer";

// The polished answer with its bracketed "add this" placeholders in their own colour.
export function PolishedAnswerText({ text, fallback = "" }) {
  const parts = splitPlaceholders(text);
  if (!parts.length) return fallback;
  return parts.map((p, i) => (p.placeholder ? (
    <span key={i} className="font-semibold text-amber-700" data-testid="polished-answer-placeholder">{p.text}</span>
  ) : (
    <React.Fragment key={i}>{p.text}</React.Fragment>
  )));
}
